// import common service classes
import {AngularServices} from './angular-services/angular-services.ts'
import {DevTools} from './dev-tools/dev-tools.ts'
import {AppServices} from './app-services/app-services.ts'
import {TransitionManager} from './transition-manager/transition-manager.ts'
import {ScreenManager} from './screen-manager/screen-manager.ts'
import {FullscreenManager} from './fullscreen-manager/fullscreen-manager.ts'
import {UserAgentManager} from './user-agent-manager/user-agent-manager.ts'
import {AudioManager} from './audio-manager/audio-manager.ts'
import {PixiManager} from './pixi-manager/pixi-manager.ts'
import {LocalStorageManager} from './localstorage-manager/localstorage-manager.ts'
import {DataManager} from './data-manager/data-manager.ts'
import {ColorManager} from './color-manager/color-manager.ts'
import {ModalManager} from './modal-manager/modal-manager.ts'
import {HeroManager} from './hero-manager/hero-manager.ts'
import {CarouselManager} from './carousel-manager/carousel-manager.ts'
import {ProgressManager} from './progress-manager/progress-manager.ts'
import {TrackingManager} from './tracking-manager/tracking-manager.ts'

// bind common service classes into angular services
export default angular.module('app.common.services', [])
.service('AngularServices', AngularServices)
.service('AppServices', AppServices)
.service('DevTools', DevTools)
.service('TransitionManager', TransitionManager)
.service('ScreenManager', ScreenManager)
.service('FullscreenManager', FullscreenManager)
.service('UserAgentManager', UserAgentManager)
.service('AudioManager', AudioManager)
.service('PixiManager', PixiManager)
.service('LocalStorageManager', LocalStorageManager)
.service('DataManager', DataManager)
.service('ColorManager', ColorManager)
.service('ModalManager', ModalManager)
.service('HeroManager', HeroManager)
.service('CarouselManager', CarouselManager)
.service('ProgressManager', ProgressManager)
.service('TrackingManager', TrackingManager)



/** WEBPACK FOOTER **
 ** ./src/common/services/services.ts
 **/